import { get_profile, update_profile } from '@modv/sdk'

export default {
  namespaced: true,
  state: {
    profile: {}
  },
  getters: {},
  mutations: {
    GET_PROFILE: (state, res) => {
      state.profile = res.data
    },
    GET_DISK_USAGE: (state, res) => {
      state.diskUsage = res.data
    },
    UPDATE_PROFILE: (state, res) => {
      state.profile = res.data
    },
    UPDATE_DISK_USAGE: (state, res) => {
      state.diskUsage.rawSize += res.fileSize
    }
  },
  actions: {
    async load({ commit }) {
      const res = await get_profile()
      commit('GET_PROFILE', res)
      return res
    },

    async updateDiskUsage({ commit }, params) {
      commit('UPDATE_DISK_USAGE', { fileSize: params.fileSize })
    },
    async updateProfileDetails({ commit }, params) {
      const profile = { firstName: params.firstName, lastName: params.lastName }
      commit(
        'UPDATE_PROFILE',
        await update_profile({
          $body: profile
        })
      )
    }
  }
}
